import middlewareAdapter from '@bonnet/express-middleware-adapter';
import brandParser from '@atc/brand-express-middleware';
import withBrandClient from './withBrandClient';
export default (function () {
  let {
    brandDuck
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [middlewareAdapter(brandParser()), withBrandClient({
    brandDuck
  })];
});